import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { I18nService } from './i18n.service';
import { ApiResponse } from '../models/api-response';
import { FootballGroup } from '../models/football/football-group.model';

@Injectable()
export class FootballService {

  private readonly eventBasePath: string = '/api/v1/event';
  private readonly superLigAlias = 'trendyolSuperlig_maclari';
  private readonly nesineAlias = 'altLig_maclari';
  private readonly kombineAlias = 'futbol_kombineler';

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private i18n: I18nService
  ) {}

  getSuperLigMatches(): Observable<ApiResponse<FootballGroup>> {
    return this.getEventGroup(this.superLigAlias);
  }

  getLowerLeagueMatches(): Observable<ApiResponse<FootballGroup>> {
    return this.getEventGroup(this.nesineAlias);
  }

  getSeasonTickets(): Observable<ApiResponse<FootballGroup>> {
    return this.getEventGroup(this.kombineAlias);
  }

  private getEventGroup(alias: string): Observable<ApiResponse<FootballGroup>> {
    const lang = this.i18n.currentLang;

    return this.http.get<ApiResponse<FootballGroup>>(
      `${this.apiService.getCrmApiHost()}${this.eventBasePath}/getEventGroups/${alias}/${lang}`
    );
  }
}
